import { Component, Optional } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialogRef } from '@angular/material/dialog';
import { routes } from '../../../../constants/routes';

@Component({
  selector: 'app-request-sent-dialog',
  standalone: true,
  templateUrl: './request-sent-dialog.component.html',
  styleUrl: './request-sent-dialog.component.scss',
})
export class RequestSentDialogComponent {
  constructor(
    private router: Router,
    @Optional()
    private matDialogRef: MatDialogRef<RequestSentDialogComponent> | null
  ) {
    if (matDialogRef) matDialogRef.disableClose = true;
  }

  redirectToHome() {
    this.matDialogRef.close();
    this.matDialogRef.afterClosed().subscribe(() => {
      this.router.navigate(['/', routes.home], {
        replaceUrl: true,
      });
    });
  }
}
